/* Filters the records already rendered for this account. No requests or record changes. */
(function () {
  'use strict';
  if (window.stellarSavorWorkspacesMounted) return;
  window.stellarSavorWorkspacesMounted = true;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  function mount(scope) {
    const roots = [...scope.querySelectorAll('[data-savor-search]')];
    if (scope.matches?.('[data-savor-search]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.savorSearchMounted) return;
      const items = [...root.querySelectorAll('[data-savor-item]')];
      const toolbar = root.querySelector('[data-savor-toolbar]');
      const query = root.querySelector('[data-savor-query]');
      const filter = root.querySelector('[data-savor-filter]');
      const ready = root.querySelector('[data-savor-ready-only]');
      const count = root.querySelector('[data-savor-count]');
      const empty = root.querySelector('[data-savor-no-results]');
      const clear = root.querySelector('[data-savor-clear]');
      if (!items.length || !toolbar || !query || !count) return;
      root.dataset.savorSearchMounted = 'true';
      const records = items.map(item => ({item, text: normalize(item.dataset.savorText || item.textContent), status: normalize(item.dataset.savorStatus), category: normalize(item.dataset.savorCategory), ready: item.dataset.savorReady === 'true'}));
      function update() {
        const terms = normalize(query.value).split(/\s+/).filter(Boolean);
        const selection = normalize(filter?.value);
        let visible = 0;
        records.forEach(record => {
          const matchesStatus = !selection || selection === 'all' || (selection === 'attention' ? ['offered', 'count_due'].includes(record.status) : [record.status, record.category].includes(selection));
          const matches = terms.every(term => record.text.includes(term)) && matchesStatus && (!ready?.checked || record.ready);
          record.item.hidden = !matches;
          if (matches) visible += 1;
        });
        root.querySelectorAll('[data-savor-group]').forEach(group => {
          group.hidden = ![...group.querySelectorAll('[data-savor-item]')].some(item => !item.hidden);
        });
        const singular = root.dataset.savorSingular || 'result';
        const plural = root.dataset.savorPlural || 'results';
        count.textContent = visible + ' of ' + items.length + ' ' + (items.length === 1 ? singular : plural);
        if (empty) empty.hidden = visible !== 0;
        if (clear) clear.hidden = !terms.length && (!selection || selection === 'all') && !ready?.checked;
      }
      query.addEventListener('input', update);
      filter?.addEventListener('change', update);
      ready?.addEventListener('change', update);
      clear?.addEventListener('click', () => { query.value = ''; if (filter) filter.value = 'all'; if (ready) ready.checked = false; update(); query.focus(); });
      toolbar.hidden = false;
      update();
    });
  }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
